import stockService from 'common/services/stockService'
import modelCnfirmPage from './views/readConfirm.html'
import utils from 'utils'

export default class ApplicationListCtrl {
    constructor($scope, logger, httpRequest, $uibModal, sweetalert, $timeout) {
        /**
         * 格式化日期，不在Dateprototype上加方法
         */
        function getFormatedDate(date) {
            const year = date.getFullYear()
            let month = date.getMonth() + 1
            month = month < 10 ? `0${month}` : `${month}`
            let dateStr = date.getDate()
            dateStr = dateStr < 10 ? `0${dateStr}` : `${dateStr}`
            return `${year}-${month}-${dateStr}`
        }
        /**
         * 计算起止时间间隔
         */
        function calculatePeriodInteval(startDate, endDate) {
            const day = 24 * 60 * 60 * 1000
            // 不兼容IE8
            const interval = new Date(endDate).getTime() - new Date(startDate).getTime()
            return interval / day
        }

        function convertInvType(item) {
            if (item.invoiceType === '51') {
                item.invoiceType1 = '026'
            } else {
                item.invoiceType1 = item.invoiceType
            }
        }
        const userInfo = JSON.parse(localStorage.user_info)
        var ukeyList = userInfo.sysUkeyList;
        const orgId = userInfo.org.orgId;
        if(null!=ukeyList && ukeyList.length>0){
            var u_index = 0;
            ukeyList.forEach((item) => {
                u_index++;
                if(orgId!=item.orgId || item.diskType==1 || (item.diskType==2 && item.diskCode!=0 && item.manageType!=4)){
                    //不是本机构的设备，服务器盘，金税盘不是0号盘的都屏蔽( 屏蔽不是A20 )
                    u_index--
                    ukeyList.splice(u_index,1)
                }
            });
        }else{
            ukeyList = null;
        }
        $scope.ukeyList = ukeyList;
        /**
         * 检查当前是否0号盘
         * @return {[type]} [description]
         */
        function checkDisk() {
            /*const opening = window.layer.msg('加载中...', {
                time: 0, skin: 'layer-loading-self', icon: 16, shade: 0.5,
            })*/
            const errorMsg1 = '未检测到0号开票机，请插入后，重新刷新本页面'
            const errorMsg2 = '当前插入设备税号与用户税号不一致'
            const $page = $('#stock-application-page')
            if (IS_MAIN_DISK) {
                $page.show()
                $scope.queryList()
                $scope.errorMsg = ''
                window.layer.close(opening)
                return
            }
            $page.show();
            /*stockService.getDiskInfo().then((res) => {
                const data = JSON.parse(res)
                if ($scope.userInfo.sale && $scope.userInfo.sale.saleCreditCode !== data.TaxCode) {
                    $page.hide()
                    $scope.errorMsg = errorMsg2
                } else if (data.kpfwqh !== '0') {
                    $page.hide()
                    $scope.errorMsg = errorMsg1
                } else {
                    $page.show()
                    $scope.queryList()
                }
                window.layer.close(opening)
            }, (error) => {
                $timeout(() => {
                    $scope.errorMsg = errorMsg1
                    $page.hide()
                    window.layer.close(opening)
                })
                logger.logError(error || '获取金税盘信息失败')
            })*/
        }

        function genDictionary() {
            $scope.dictionary = {
                statusList: [
                    {
                        enumCode: '1',
                        enumName: '成功',
                    },
                    {
                        enumCode: '2',
                        enumName: '失败',
                    },
                    {
                        enumCode: '0',
                        enumName: '申领中',
                    },
                ],
                applyWays: [
                    {
                        enumName: '自行领取',
                        enumCode: '1',
                    },
                    {
                        enumName: '快递配送',
                        enumCode: '2',
                    },
                ],
            }
            /*const typecodeArrStr = '["buy_status","stock_inv_type"]'
            httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
                Object.assign($scope.dictionary, res.data.value)
            })*/
            const typecodeArrStr = '["buy_status","apply_status"]'
            httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
                Object.assign($scope.dictionary, res.data.value)
            })
            const openApiInvType = [{enumTypeCode: 'inv_type', enumName: '专用发票', enumCode: '1', remark: ''}
                ,{enumTypeCode: 'inv_type', enumName: '普通发票', enumCode: '2', remark: ''},
                {enumTypeCode: 'inv_type', enumName: '机动车发票', enumCode: '3', remark: ''},
                {enumTypeCode: 'inv_type', enumName: '卷式发票', enumCode: '4', remark: ''},
                {enumTypeCode: 'inv_type', enumName: '电子普通发票', enumCode: '5', remark: ''},
                {enumTypeCode: 'inv_type', enumName: '电子专用发票', enumCode: '6', remark: ''},
                {enumTypeCode: 'inv_type', enumName: '二手车', enumCode: '7', remark: ''}]
            $scope.dictionary.stock_inv_type = openApiInvType
            $scope.dictionary.stock_invtype = [{enumCode:'0',enumName:'纸质专用发票'},{enumCode:'004',enumName:'纸质专用发票'}
                ,{enumCode:'2',enumName:'纸质普通发票'},{enumCode:'007',enumName:'纸质普通发票'}
                ,{enumCode:'12',enumName:'机动车发票'},{enumCode:'005',enumName:'机动车发票'}
                ,{enumCode:'41',enumName:'卷式发票'},{enumCode:'025',enumName:'卷式发票'}
                ,{enumCode:'51',enumName:'电子普通发票'},{enumCode:'026',enumName:'电子普通发票'}
                ,{enumCode:'52',enumName:'电子专用发票'},{enumCode:'028',enumName:'电子专用发票'}]
        }
        $scope.reset = function () {
            $scope.queryParam = {
                applyDateStart: getFormatedDate(new Date(new Date().setDate(new Date().getDate() - 3))),
                applyDateEnd: getFormatedDate(new Date()),
                invoiceType: '5',
                status: '',
                diskId: null==ukeyList?'':ukeyList[0].diskId
            }
        }
        function init() {
            $scope.errorMsg = ''
            $scope.queryParam = {
                applyDateStart: '',
                applyDateEnd: '',
                invoiceType: '5',
                status: '',
                diskId: null==ukeyList?'':ukeyList[0].diskId,
            }
            $scope.pageParam = {
                total: 0,
                pageNum: 1,
                pageSize: 10,
            }
            // 全部数据
            $scope.allListData = []
            // 分页后数据
            $scope.listData = []
            // 设置默认查询时间段
            const now = new Date()
            $scope.queryParam.applyDateEnd = getFormatedDate(now)
            now.setDate(now.getDate() - 3)
            $scope.queryParam.applyDateStart = getFormatedDate(now)
            genDictionary()
            checkDisk()
        }
        $scope.queryList = function queryList() {
            if(null==$scope.queryParam.diskId){
                logger.logError('请选择一个有效申领设备')
                return
            }
            if (calculatePeriodInteval($scope.queryParam.applyDateStart, $scope.queryParam.applyDateEnd) > 90) {
                logger.logError('起止日期不能超过90天')
                return
            }
            const param = {
                ...$scope.queryParam,
                applyDateStart: $scope.queryParam.applyDateStart.replace(/-/g, ''),
                applyDateEnd: $scope.queryParam.applyDateEnd.replace(/-/g, ''),
            }
            var selectedDisk = null;
            ukeyList.forEach((item) => {
                if(item.diskId==$scope.queryParam.diskId){
                    selectedDisk = item
                }
            });
            if(null==selectedDisk){
                logger.logError('选择的设备与您拥有的设备权限不一致')
                return
            }
            if(selectedDisk.diskType==2 && selectedDisk.manageType==0){
                //金税盘本地单机
                stockService.queryApplications(param).then((res1) => {
                    stockService.queryReadStatus().then((res2) => {
                        const cloudParam = {
                            ...$scope.queryParam,
                            responseData: res1,
                            downloadResponseData: res2,
                        }
                        httpRequest.post_queryOvatOnlineApplyRecord(cloudParam).then((res3) => {
                            $scope.allListData = res3.data.value
                            $scope.pageParam.total = res3.data.value.length
                            $scope.page()
                        })
                    }, (error) => {
                        logger.logError(error)
                    })
                }, (error) => {
                    logger.logError(error)
                })
            }else if(selectedDisk.manageType==3){
                //调用后台查询申领记录
                utils.loading('数据加载中')
                const requestData = {
                    taxNo: userInfo.sale.saleCreditCode,
                    invoiceCategory: $scope.queryParam.invoiceType,
                    startTime: $scope.queryParam.applyDateStart.replace(/-/g, ''),
                    endTime: $scope.queryParam.applyDateEnd.replace(/-/g, ''),
                    applicationStatus: $scope.queryParam.status
                }
                httpRequest.post_queryApplyState(requestData).then((res) =>{
                    utils.loaded()
                    $scope.allListData = []
                    $scope.pageParam.total = 0
                    if(res.data.value && res.data.value.businessData && res.data.value.businessData.length>0){
                        $scope.pageParam.total = res.data.value.businessData.length
                        res.data.value.businessData.forEach((item)=>{
                            const _item = {
                                buyStatus: item.applyStatus,
                                invoiceTypeName: item.typeName,
                                applyCount: item.applyAmount,
                                applyDate: item.applyTime,
                                applyStatusMsg: item.applyStatusMsg,
                                invoiceType: item.invType,
                                applyStatus: item.applyStatus,
                                applyNum: item.applyNum
                            }
                            $scope.allListData.push(_item)
                        })
                    }
                    $scope.page()
                },(error)=>{
                    utils.loaded()
                    logger.logError(error)
                })
            }else if(selectedDisk.manageType==4){
                //调用后台查询申领记录
                utils.loading('数据加载中')
                const requestData = {
                    dealDateStart: $scope.queryParam.applyDateStart,
                    dealDateEnd: $scope.queryParam.applyDateEnd,
                    operateStatus: $scope.queryParam.status
                }
                httpRequest.post_queryOvatOnlineApplyRecordDetail(requestData).then((res) =>{
                    utils.loaded()
                    $scope.allListData = []
                    $scope.pageParam.total = 0
                    if(res.data.value && res.data.value.list && res.data.value.list.length>0){
                        $scope.pageParam.total = res.data.value.total
                        res.data.value.list.forEach((item)=>{
                            const _item = {
                                applyStatusMsg: item.applyStatus,
                                invoiceType: item.invoiceType,
                                applyCount: item.applyCount,
                                applyDate: item.applyDate,
                                taskNum: item.taskNum,
                                applyStatus: item.applyStatus,
                                applyNum: item.applySn
                            }
                            $scope.allListData.push(_item)
                        })
                    }
                    $scope.page()
                },(error)=>{
                    utils.loaded()
                    logger.logError(error)
                })
            }else{
                logger.logError('当前设备使用的开票方式不支持查询')
            }

        }
        init()
        $scope.page = function page() {
            if (!$scope.allListData || $scope.allListData.length === 0) {
                $scope.listData = []
                return
            }

            const { pageParam } = $scope
            const start = (pageParam.pageNum - 1) * pageParam.pageSize
            const end = pageParam.pageNum * pageParam.pageSize
            $scope.listData = $scope.allListData.slice(start, end)
        }
        function openOperationConfirm(item) {
            item.invoiceCount = item.applyCount
            return $uibModal.open({
                template: modelCnfirmPage,
                controller: 'readConfirmCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal-application-read mod-modal mod-modal-lg',
                resolve: {
                    applyRecord() {
                        return item
                    },
                },
            }).result
        }
        /**
         * 1.本地盘确认 2。然后读入 3. 发票卷数据传后台
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.read = function read(item) {
            convertInvType(item)
            if (!item.invoiceVolumeList || item.invoiceVolumeList.length === 0) {
                logger.logError('没有获取到发票卷信息')
                return
            }
            openOperationConfirm(item).then(() => {
                const opening = window.layer.msg('读入中...', {
                    time: 0, skin: 'layer-loading-self', icon: 16, shade: 0.5,
                })
                let QRXX = ''
                item.invoiceVolumeList.forEach((volume) => {
                    QRXX += `<QRXX><FPDM>${volume.invoiceCode}</FPDM><QSHM>${volume.invoiceNumberStart}</QSHM><ZZHM>${volume.invoiceNumberEnd}</ZZHM></QRXX> `
                })
                item.QRXX = QRXX
                stockService.applyConfirm(item).then(() => {
                    let readParam
                    if (item.invoiceType === '51') {
                        readParam = {
                            applySn: item.applySn,
                            invoiceType: item.invoiceType,
                            applyCount: item.applyCount,
                        }
                    } else {
                        readParam = item
                    }
                    stockService.readToMainDisk(readParam).then(() => {
                        item.operateStatus = '1'
                        httpRequest.post_updateOnlineApplyRecord(item).then(() => {
                            logger.logSuccess('发票读入成功')
                            $scope.queryList()
                            window.layer.close(opening)
                        })
                    }, (error) => {
                        logger.logError(error)
                        window.layer.close(opening)
                    })
                }, (error) => {
                    logger.logError(error)
                    window.layer.close(opening)
                })
            })
        }
        $scope.revert = function revert(item) {
            var requestData = {
                taxNo: userInfo.sale.saleCreditCode,
                applyNum: item.applyNum,
                applyAmount: item.applyCount
            }
            if(item.invoiceType==='0' || item.invoiceType==='004'){
                requestData.invoiceCategory = '1'
            }else if(item.invoiceType==='2' || item.invoiceType==='007'){
                requestData.invoiceCategory = '2'
            }else if(item.invoiceType==='12' || item.invoiceType==='005'){
                requestData.invoiceCategory = '3'
            }else if(item.invoiceType==='41' || item.invoiceType==='025'){
                requestData.invoiceCategory = '4'
            }else if(item.invoiceType==='51' || item.invoiceType==='026'){
                requestData.invoiceCategory = '5'
            }else if(item.invoiceType==='52' || item.invoiceType==='028'){
                requestData.invoiceCategory = '6'
            }else{
                requestData.invoiceCategory = '7'
            }

            var selectedDisk = null;
            ukeyList.forEach((item) => {
                if(item.diskId==$scope.queryParam.diskId){
                    selectedDisk = item
                }
            });

            if(selectedDisk.manageType==4){
                sweetalert.confirm('发票撤销', '确定要撤销申领发票申请？').then(() => {
                    const opening = window.layer.msg('撤销中...', {
                        time: 0, skin: 'layer-loading-self', icon: 16, shade: 0.5,
                    })
                    httpRequest.get_invoiceApplyCancel(item.applyNum).then(() => {
                        window.layer.close(opening)
                        logger.logSuccess('发票撤销成功')
                        $scope.queryList()
                    }, (error) => {
                        window.layer.close(opening)
                        logger.logError(error)
                    })
                }, () => { })
            }else {
                sweetalert.confirm('发票撤销', '确定要撤销申领发票申请？').then(() => {
                    const opening = window.layer.msg('撤销中...', {
                        time: 0, skin: 'layer-loading-self', icon: 16, shade: 0.5,
                    })
                    httpRequest.post_applyRevoke(requestData).then(() => {
                        window.layer.close(opening)
                        logger.logSuccess('发票撤销成功')
                        $scope.queryList()
                    }, (error) => {
                        window.layer.close(opening)
                        logger.logError(error)
                    })
                }, () => { })
            }
            /*convertInvType(item)
            sweetalert.confirm('发票撤销', '确定要撤销申领发票申请？').then(() => {
                const opening = window.layer.msg('撤销中...', {
                    time: 0, skin: 'layer-loading-self', icon: 16, shade: 0.5,
                })
                stockService.revertApplication(item).then(() => {
                    item.operateStatus = '2'
                    httpRequest.post_updateOnlineApplyRecord(item).then(() => {
                        window.layer.close(opening)
                        logger.logSuccess('发票撤销成功')
                        $scope.queryList()
                    }, () => {
                        window.layer.close(opening)
                    })
                }, (error) => {
                    window.layer.close(opening)
                    logger.logError(error)
                })
            }, () => { })*/
        }
        $scope.synchro = function synchro(item) {
            console.log(item)
            sweetalert.confirm('同步购票状态', '确定要同步购票状态？').then(() => {
                const opening = window.layer.msg('同步中...', {
                    time: 0, skin: 'layer-loading-self', icon: 16, shade: 0.5,
                })
                httpRequest.get_getInvoiceApplyResult(item.taskNum).then(() => {
                    window.layer.close(opening)
                    logger.logSuccess('同步购票状态成功')
                    $scope.queryList()
                }, (error) => {
                    window.layer.close(opening)
                    logger.logError(error)
                })
            }, () => { })

        }
        $scope.canRevert = function canRevert(item) {
            // 是电子票且申领状态为0
            if ((item.invoiceType === '51' || item.invoiceType === '026' || item.invoiceType === '52' || item.invoiceType === '028') && item.applyStatus === '0') {
                return true
            }
            // 不是电子票申领状态为1
            if ((item.invoiceType !== '51' && item.invoiceType !== '026' && item.invoiceType !=='52' && item.invoiceType !=='028') && item.applyStatus === '1') {
                return true
            }
            return false
        }

        $scope.canRead = function canRead(item) {
            return item.operateStatus === '0'
        }
        $scope.canApplyStatus =function canApplyStatus(){
            var selectedDisk = null;
            ukeyList.forEach((item) => {
                if(item.diskId==$scope.queryParam.diskId){
                    selectedDisk = item
                }
            });
            if(selectedDisk.manageType!=4 ){
                return true
            }
        }
        $scope.canSynchro =function canSynchro(){
            var selectedDisk = null;
            ukeyList.forEach((item) => {
                if(item.diskId==$scope.queryParam.diskId){
                    selectedDisk = item
                }
            });
            if(selectedDisk.manageType==4){
                return true
            }
        }
    }
}
ApplicationListCtrl.$inject = ['$scope', 'logger', 'httpRequest', '$uibModal', 'sweetalert', '$timeout']



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/application/applicationListCtrl.js